// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableHistoryCoin_Component__1T11a"};